// Утилита для вычисления даты «армейской смены» с границей 20:00.
// По ТЗ «Рабочие задачи» блок 5: смена идёт с 20:00 предыдущего дня по 20:00 следующего.
// После 20:00 система должна работать с сутками СЛЕДУЮЩЕГО календарного дня.
//
// Пример:
//   28.04 19:59 → shiftDate = 2026-04-28  (текущая смена ещё «сегодня»)
//   28.04 20:00 → shiftDate = 2026-04-29  (заступает новая смена «завтра»)
//   29.04 07:00 → shiftDate = 2026-04-29  (смена продолжается)
//   29.04 19:59 → shiftDate = 2026-04-29
//   29.04 20:00 → shiftDate = 2026-04-30
//
// Граница может быть переопределена через параметр (для тестов / калибровки).
export const SHIFT_BOUNDARY_HOUR = 20

export function getShiftDate(now = new Date(), boundaryHour = SHIFT_BOUNDARY_HOUR) {
  const src = (now instanceof Date) ? now : new Date()
  const shiftedMs = src.getTime() + (24 - boundaryHour) * 60 * 60 * 1000
  const shifted = new Date(shiftedMs)
  // Берём календарную дату «сдвинутого» момента — это и есть день смены.
  const two = (n) => (n < 10 ? `0${n}` : String(n))
  return `${shifted.getFullYear()}-${two(shifted.getMonth() + 1)}-${two(shifted.getDate())}`
}

// Человекочитаемое описание текущей смены — для индикатора в шапке.
// Например: «Смена: 29.04 (20:00 28.04 — 20:00 29.04)».
export function describeShift(now = new Date(), boundaryHour = SHIFT_BOUNDARY_HOUR) {
  const shiftDay = getShiftDate(now, boundaryHour)
  const [y, m, d] = shiftDay.split('-').map(Number)
  const shiftDate = new Date(y, m - 1, d)
  const prev = new Date(y, m - 1, d - 1)
  const two = (n) => (n < 10 ? `0${n}` : String(n))
  const fmt = (dt) => `${two(dt.getDate())}.${two(dt.getMonth() + 1)}`
  return {
    date: shiftDay,
    label: `Смена: ${fmt(shiftDate)} (${boundaryHour}:00 ${fmt(prev)} — ${boundaryHour}:00 ${fmt(shiftDate)})`,
    startsAt: new Date(prev.getFullYear(), prev.getMonth(), prev.getDate(), boundaryHour, 0),
    endsAt: new Date(shiftDate.getFullYear(), shiftDate.getMonth(), shiftDate.getDate(), boundaryHour, 0),
  }
}
